import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import { AllEmployeeDetailsQuery } from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import BASEURL from "../Utils/Baseurl";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";


export default function EmployeesListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [employeeData, setEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  //UseEffect for Fetching Function
  useEffect(() => {
    fetchEmployeeData();
    setStatus(false);
  }, [id, status]);

  //Table Mapping
  const employeeListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.No",
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "User Name",
        field: "username",
        name: "Employee Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Email ID",
        field: "email",
        name: "Email ID",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Role",
        field: "role",
        name: "Role",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Contact No",
        field: "contactno",
        name: "Contact No",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: employeeData.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      username: v.username,
      email: v.email,
      role: v.role,
      contactno: v.contactno,
    })),
  };

  //Fetch Table Data
  const fetchEmployeeData = () => {
    setIsLoading(true);
    request(BASEURL, AllEmployeeDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setEmployeeData(res.getUserDetailByMaster);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //Add Employee
  const handleNewEmployee = () => {
    navigate("/employee/add-employees");
  };

  //Row Click
  const onEmployeeListClick = (e) => {
    if (e?.id) {
      navigate(`/employee/add-employees?${e?.id}`);
    }
  };

  const onDelete=(id)=>
    {
      console.log("id-d",id)
    }
    
    const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
    const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={employeeListTable.columns}
      rowsData={employeeListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Employee List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onEmployeeListClick}
      onDelete={onDelete}
      onView={onEmployeeListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewEmployee()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Employee List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewEmployee()}
              >
                Add Employee
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={employeeListTable.rows}
            columns={employeeListTable.columns}
            isSelectable={false}
            onRowClick={onEmployeeListClick}
            loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Employee found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any Employee details. Click on the "Add
                    Employee" button to start adding employee details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
